import { useAppStore } from "@/stores/app"

export function formatDate(date: Date | string | number, format = 'YYYY-MM-DD HH:mm:ss'): string {
  const d = new Date(date)
  if (Number.isNaN(d.getTime())) return ''
  const map: Record<string, string> = {
    YYYY: String(d.getFullYear()),
    MM: String(d.getMonth() + 1).padStart(2, '0'),
    DD: String(d.getDate()).padStart(2, '0'),
    HH: String(d.getHours()).padStart(2, '0'),
    mm: String(d.getMinutes()).padStart(2, '0'),
    ss: String(d.getSeconds()).padStart(2, '0')
  }
  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (m) => map[m])
}

export function debounce<T extends (...args: never[]) => unknown>(fn: T, delay = 300) {
  let timer: ReturnType<typeof setTimeout> | null = null
  return (...args: Parameters<T>) => {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => fn(...args), delay)
  }
}

export function throttle<T extends (...args: never[]) => unknown>(fn: T, delay = 300) {
  let last = 0
  return (...args: Parameters<T>) => {
    const now = Date.now()
    if (now - last >= delay) {
      last = now
      fn(...args)
    }
  }
}

export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
// const PHONE_REGEX = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[013578]|18[0-9]|19[168])\d{8}$/

export function isValidEmail(value: string): boolean {
  return EMAIL_REGEX.test(value)
}

export function isValidPhone(value: string): boolean {
  const { mobileReg } = useAppStore();
  // 从字符串构建正则对象
  const reg = new RegExp(mobileReg);
  const match = value.match(reg);
  if (!match) return false;
  return true;
  // const groups = match.groups;
  // if (groups.cmcc) return "中国移动";
  // if (groups.cucc) return "中国联通";
  // if (groups.ctcc) return "中国电信";
  // if (groups.cbn) return "中国广电";
  // if (groups.vsp) return "虚拟运营商";
  // return "未知";
}

export function isEmailOrPhone(value: string): 'email' | 'phone' | null {
  if (isValidEmail(value)) return 'email'
  if (isValidPhone(value)) return 'phone'
  return null
}

export function uniqueId(prefix = 'id'): string {
  return `${prefix}_${Math.random().toString(36).slice(2, 9)}`
}

export function deepClone<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') return obj
  if (obj instanceof Date) return new Date(obj.getTime()) as unknown as T
  if (obj instanceof Array) return obj.map((item) => deepClone(item)) as unknown as T
  if (typeof obj === 'object') {
    const cloned = {} as Record<string, unknown>
    Object.keys(obj as object).forEach((key) => {
      cloned[key] = deepClone((obj as Record<string, unknown>)[key])
    })
    return cloned as unknown as T
  }
  return obj
}

export function formatPrice(price?: number | null, currency = '$'): string {
  if (price === undefined || price === null || isNaN(price)) return `${currency}0.00`
  return `${currency}${price.toFixed(2)}`
}

export function isToday(date: Date | string | number): boolean {
  const d = new Date(date)
  const now = new Date()
  return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth() && d.getDate() === now.getDate()
}
